export default __webpack_public_path__ + "static/media/spinWheel.e5bae901.mp3";